import Page from './page';
import createi18n from './createi18n';

const i18nInstance = createi18n(Page.getLocaleJson(), Page.getLocale());
export default i18nInstance;
